<template>
    <div class="container">
        <div class="main">
            <div class="banner">
                <el-carousel height="660px" arrow="always" >
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <!-- <video height="300px" loop="loop" autoplay><source :src="item" type="video/mp4"/></video> -->
                        <a href="#">
                            <img v-if="languageType == 0" @click="toProductdetail(item.categoryId,item.productName)" :src="item.picUrl"/>
                            <img v-else @click="toProductdetail(item.categoryId,item.productName)" :src="item.enPicUrl"/>
                        </a>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="new_arrivals">
                <div class="title">
                    <p>新品推荐</p>
                    <p>New Product</p>
                </div>
                <div class="content_pic">
                    <div class="pic_left" @click="toProductdetail(newproducts[0].categoryId,newproducts[0].productName)">
                        <img :src="newproductList[0]"/>
                    </div>
                    <div class="pic_right">
                        <div class="right_top" @click="toProductdetail(newproducts[1].categoryId,newproducts[1].productName)"><img :src="newproductList[1]"/></div>
                        <div class="right_buttom">
                            <div class="buttom_left" @click="toProductdetail(newproducts[2].categoryId,newproducts[2].productName)"><img :src="newproductList[2]"/></div>
                            <div class="buttom_right" @click="toProductdetail(newproducts[3].categoryId,newproducts[3].productName)"><img :src="newproductList[3]"/></div>
                        </div>
                    </div>
                </div>
                <div class="more" @click="$router.push({ name: 'newproduct'}),$emit('changeIndex','2')"><span>More</span><span>+</span></div>
            </div>
            <div class="product_display">
                <div class="title">
                    <p>产品展示</p>
                    <p>Product display</p>
                </div>
                <div class="product_menu">
                    <ul>
                        <li v-for="(item,index) in productMenuList" :key="index" :class="productIndex == item.sort?'active':''" @click="checkProduct(item.id,item.sort)">
                            <div class="text">
                                <p>{{ item.name }}</p>
                                <span>{{ item.enName}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="product_list">
                    <ul>
                        <li v-for="(item,index) in productList"  v-if="languageType == 1&&item.enName == ''?false:true" :key="index" @click="toProductdetail(productIndex,item.name)">
                            <div class="picter">
                                <img :src="item.picUrl"/>
                            </div>
                            <div class="text">
                                <p>{{languageType == 0? item.name:item.enName }}</p>
                                <span>{{ languageType == 0?item.detail:item.enDetail }}</span>
                            </div>
                        </li>
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="more" @click="$router.push({ name: 'product'}),$emit('changeIndex','5')"><span>More</span><span>+</span></div>
            </div>
            <div class="place_display">
                <div class="title">
                    <p>场地展示</p>
                    <p>Venue display</p>
                </div>
                <div class="card">
                    <el-carousel :interval="4000" type="card" height="360px" arrow="always" indicator-position="none">
                        <el-carousel-item v-for="(item,index) in placeList" :key="index">
                            <img style="width:640px" :src="item.picUrl"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <!-- <div class="wrap" id="wrap">
                   <ul class="content"></ul>
                    <a href="javascript:;" class="prev"></a>
                    <a href="javascript:;" class="next"></a>
                </div> -->
            </div>
            <div class="exhibition">
                <div class="title">
                    <p>新闻和展会信息</p>
                    <p>News and Information</p>
                </div>
                <div class="exhibition_list">
                    <ul>
                        <li v-for="(item,index) in exhibitionList" :key="index" @click="toExhibitiondetail(item.id)">
                            <div class="picter">
                                <img :src="item.pic"/>
                            </div>
                            <div class="text">
                                <p>{{ languageType == 0? item.name:item.enName  }}</p>
                                <span>{{ languageType == 0?item.detail:item.enDetail  }}</span>
                            </div>
                        </li>
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="more" @click="$router.push({ name: 'exhibition'}),$emit('changeIndex','1')"><span>More</span><span>+</span></div>
            </div>
            <div class="enterprise_intro">
                <div class="title">
                    <p>企业介绍</p>
                    <p>Enterprise introduction</p>
                </div>
                <div class="english_intro">Guangzhou Arccer Amusement Technology Co., Ltd</div>
                <div class="content_intro">
                    <div class="intro_left">
                        <img :src="enterprisePic"/>
                    </div>
                    <div class="intro_right" :class="languageType == 1?'intro_right_en':''">
                        <div class="company_name">
                            <span v-if="languageType == 0">广州市胜骅动漫科技有限公司</span>
                            <span v-else>Guangzhou Arccer Amusement Technology Co.,Ltd.</span>
                        </div>
                        <div class="company_intro" :class="languageType == 1?'company_intro_en':''">
                            <span v-if="languageType == 0">广州市胜骅动漫科技有限公司,始创于1998年，是一家集研发、生产、销售、服务为一体的商用游戏机专业提供商。“产品创新”和“专业服务”一直是胜骅蓬勃生命力的核心价值。</span>
                            <span v-else>Guangzhou Arccer Amusement Technology Co., Ltd, founded in 1998, is a professional provider of commercial game consoles integrating R & D, production, sales and service. "Product innovation" and "professional services" have always been the core values of Shengli's vigorous vitality.</span>
                        </div>
                        <div class="company_more" @click="$router.push({ name: 'introduce'}),$emit('changeIndex','1')" :class="languageType == 1?'company_more_en':''">
                            <p>了解更多</p>
                            <p>Learn more</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            categoryId:'',
            currenIndex:0,
            productIndex:1,
            showBghover:false,
            showLanguage:false,
            enterprisePic:'',
            language:'简',
            languages:'体中文',
            menuList:[
                {
                    title:'首页',
                    otherName:'Home',
                },
                {
                    title:'关于胜骅',
                    otherName:'About us',
                },
                {
                    title:'新品推荐',
                    otherName:'New product',
                },
                {
                    title:'联系我们',
                    otherName:'Contact us',
                },
                {
                    title:'下载中心',
                    otherName:'Download Center',
                },
                {
                    title:'产品展示',
                    otherName:'Product Display',
                }
            ],
            bannerList:[],
            productMenuList:[],
            productList:[],
            newproductList:[],
            newproducts:[],
            placeList:[],
            exhibitionList:[]
        }
    },
    created () {
        // this.languageType = sessionStorage.getItem('languageType')
        this.$emit('changeIndex',0)
        this.getBannerList()
        this.getNewproductList()
        this.getCategoryList ()
        this.getPlaceList()
        this.getExhibitionList()  
        this.getEnterpriseList() 
    },
    watch:{
        'languageType':function(a,b) {
            if(a != b){
                this.getBannerList()
                this.getNewproductList()
            }
        }

    },
    mounted () {
        var self = this
    },
    methods:{
        getBannerList () {
            this.$http({
                url: this.$http.adornUrl('/web/banner/list'),
                method: 'post',
                data: {
                     'page': '1',
                    'limit': '999',
                    'type':1,
                    'productId':'',
                    'client':''
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    let arr = []
                    data.page.list.forEach( item => {
                        if(item.client == 1){
                            if(this.languageType == 0 && item.picUrl){
                                arr.push(item)
                            }else if(this.languageType == 1 && item.enPicUrl){
                                 arr.push(item)
                            }
                        }
                    })
                    this.bannerList = arr
                } else {
                    this.bannerList = []
                }
            })
        },
        getNewproductList () {
            this.$http({
                url: this.$http.adornUrl('/web/picture/list'),
                method: 'post',
                data: {
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    let arr = [];
                    let arr2 = [];
                    data.page.forEach((item,index) =>{
                        if(this.languageType == 0 && index < 4) {
                            arr.push(item.picUrl);
                            arr2.push(item);
                        }else if(this.languageType == 1 && index >= 4) {
                            arr.push(item.enPicUrl)
                            arr2.push(item);
                        }
                        
                    })
                    this.newproductList = arr
                    this.newproducts =  arr2
                } else {
                    this.newproductList = []
                }
            })
        },
        getProductList () {
            this.$http({
                url: this.$http.adornUrl('/web/product/list'),
                method: 'post',
                data: {
                    'categoryId':this.categoryId == ''?0:this.categoryId
                }
                }).then(({data}) => {
                if(this.languageType == 1){
                    let arr = [];
                    data.page.list.forEach((a,b)=>{
                        if(a.enName != ''){
                            arr.push(a);
                        }
                    })
                    data.page.list = arr;
                }
                if (data && data.code === 0) {
                    this.productList = data.page.list.slice(0,6)
                } else {
                    this.productList = []
                }
            })
        },
        getPlaceList () {
            this.$http({
                url: this.$http.adornUrl('/web/place/list'),
                method: 'post',
                data: {
                    'page':'1',
                    'limit':'999',
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.placeList = data.page.list
                } else {
                    this.placeList = []
                }
            })
        },
        getExhibitionList () {
            this.$http({
                url: this.$http.adornUrl('/web/news/list'),
                method: 'post',
                data: {
                    page: "1",
                    limit: "3",
                    type: 2,
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.exhibitionList = data.page.list
                } else {
                    this.exhibitionList = []
                }
            })
        },
        getCategoryList () {
            this.$http({
                url: this.$http.adornUrl('/web/category/list'),
                method: 'post',
                data: {
                    'page':'1' ,
                    'limit':'999',
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.productMenuList = data.page.list.sort((a, b) => a.sort - b.sort)
                    this.categoryId = data.page.list[0].id
                    this.getProductList ()
                   
                } else {
                    this.productMenuList = []
                }
            })
        },
        getEnterpriseList () {
            this.$http({
                url: this.$http.adornUrl('/web/company/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '1',
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.enterprisePic = data.page[0].picUrl
                } else {
                    this.bannerList = []
                }
            })
        },
        checkProduct (id, sort) {
            this.productIndex = sort
            this.categoryId = id
            this.getProductList()
        },
        toProductdetail (id,name) {
            this.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}}),
            this.$emit('changeIndex',5)
        },
        toExhibitiondetail (id) {
            sessionStorage.setItem('detailId',id)
            this.$router.push({ name: 'exhibitiondetail'}),
            this.$emit('changeIndex',1)
        }
    }
}
</script>

<style lang="less" scoped>
    .container {
        width: 100%;
        .main {
            
            .banner {
                height: 660px;
                img {
                    // width: 1920px;
                    // max-width: 1920px;
                }
            }
            .new_arrivals {
                .title {
                    margin: 0 auto;
                    width: 947px;
                    position: relative;
                    margin-top: 100px;
                    p{
                        color: #e21711;
                        text-align: center;
                    }
                    p:first-child {
                        font-size: 30px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 6px;
                    }
                }
                .title::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        left: 277px;
                        background-color: #e21711;
                    }
                .title::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        right: 277px;
                        background-color: #e21711;
                }
                .content_pic {
                    margin: 0 auto;
                    margin-top: 60px;
                    overflow: hidden;
                    width: 1242px;
                    .pic_left {
                        float: left;
                        width: 480px;
                        height: 640px;
                        cursor: pointer;
                        img {
                            width: 480px;
                            height: 640px;
                            object-fit: fill
                        }
                    }
                    .pic_right {
                        float: left;
                        width: 742px;
                        height: 640px;
                        margin-left: 20px;
                        .right_top {
                            width: 742px;
                            height: 310px;
                            cursor: pointer;
                            img{
                                width: 742px;
                                height: 310px;
                                object-fit: fill
                            }
                        }
                        .right_buttom {
                            width: 742px;
                            height: 310px;
                            overflow: hidden;
                            margin-top: 20px;
                            .buttom_left {
                                width: 361px;
                                height: 310px;
                                float: left;
                                cursor: pointer;
                                img {
                                    width: 361px;
                                    height: 310px;
                                    object-fit: fill
                                }
                            }
                            .buttom_right {
                                width: 361px;
                                height: 310px;
                                float: right;
                                cursor: pointer;
                                img {
                                    width: 361px;
                                    height: 310px;
                                    object-fit: fill
                                }
                            }
                        }
                    }
                }
                .more {
                    width: 197px;
                    height: 54px;
                    margin: 0 auto;
                    margin-top: 60px;
                    background-color: #e21711;
                    text-align: center;
                    line-height: 54px;
                    cursor: pointer;
                    span {
                        color: #fff;
                        font-size: 20px;
                    }
                    span:last-child {
                        padding-top: 5px;
                    }
                }

            }
            .product_display {
                height: 1237px;
                background: url(../../static/img/product_bg.png)no-repeat center;
                background-size: cover;
                margin-top: 90px;
                padding-top: 1px;
               .title {
                    margin: 0 auto;
                    position: relative;
                    margin-top: 100px;
                    margin-bottom: 60px;
                    width: 937px;
                    p{
                        color: #e21711;
                        text-align: center;
                    }
                    p:first-child {
                        font-size: 30px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 6px;
                    }
                }
                .title::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        left: 277px;
                        background-color: #e21711;
                    }
                .title::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        right: 277px;
                        background-color: #e21711;
                }
                .product_menu {
                    height: 60px;
                    width: 937px;
                    margin: 0 auto;
                    box-shadow: 2px 2px 2px rgba(222, 222, 222, 0.5),-2px -2px 2px rgba(222, 222, 222, 0.5);
                    margin-bottom: 60px;
                    .text {
                        // height: 36px;
                        margin-top: 9px;
                    }
                    ul {
                        overflow: hidden;
                        li {
                            width: 233px;
                            height: 60px;
                            float: left;
                            border-right: 1px solid #b2b2b2;
                            background-color: #fff;
                            cursor: pointer;
                            .text {
                                &:hover {
                                p {
                                     color: #e21711;
                                }
                                span {
                                     color: #e21711;
                                }
                            }
                            }
                            
                            p {
                                font-size: 20px;
                                color: #606060;
                                height: 24px;
                            }
                            span {
                                display: inline-block;
                                height: 18px;
                                font-size: 14px;
                                color: #606060;
                            }
                            
                        }
                        li:last-child {
                            border:0;
                        }
                        li.active {
                             p {
                                        color: #fff;
                                    }
                                    span {
                                        color: #fff; 
                                    }
                            .text {
                                &:hover {
                                    p {
                                        color: #fff;
                                    }
                                    span {
                                        color: #fff; 
                                    }
                                }
                            }
                            background-color: #e21711;
                        }
                    
                    }
                }
                .product_list {
                    width: 1320px;
                    margin:auto;
                    ul {
                        // overflow: hidden;
                        width: 1320px;
                        li:nth-child(3n+0){
                            margin-right: 0
                        }
                        li {
                            width: 432px;
                            height: 344px;
                            float: left;
                            background-color: #fff;
                            margin-right: 12px;
                            margin-bottom: 12px;
                            position: relative;
                            cursor: pointer;
                            box-shadow:-3px 0 5px rgba(222, 222, 222, 0.8),3px 0 5px rgba(222, 222, 222, 0.8),
                            0 -3px 5px rgba(222, 222, 222, 0.8), 0 3px 5px rgba(222, 222, 222, 0.8);
                            .picter {
                                height: 241px;
                                img {
                                    width: 430px;
                                    height: 240px;
                                    margin-top: 1px;
                                }
                            }
                            .text {
                                width: 432px;
                                height: 103px;
                                position: relative;
                                text-align: left;
                                &:hover {
                                    p {
                                        color: #e21711;
                                    }
                                    span {
                                         color: #e21711;
                                    }
                                }
                                p {
                                    font-size: 24px;
                                    color: #000000;
                                    padding: 18px 0 0 20px;
                                }
                                span {
                                    font-size: 16px;
                                    color: #606060;
                                    margin: 5px 0 0px 20px;
                                    display: block;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                            }
                            .text::before {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 1px;
                                width: 430px;
                                height: 1px;
                                background-color: #d6d6d6;
                            }
                        }
                        li::after {
                            content: '';
                            display: block;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            width: 100%;
                            height: 9px;
                            background-color: #e21711;
                        }
                        .clear {
                            clear: both;
                            float:none;
                        }
                    }
                }
                .more {
                    width: 197px;
                    height: 54px;
                    margin: 0 auto;
                    margin-top: 48px;
                    background-color: #e21711;
                    text-align: center;
                    line-height: 54px;
                    cursor: pointer;
                    span {
                        color: #fff;
                        font-size: 20px;
                    }
                    span:last-child {
                        padding-top: 5px;
                    }
                }
            }
            .place_display {
                .title {
                    width: 450px;
                    height: 75px;
                    position: relative;
                    margin: 0 auto;
                    margin-top: 100px;
                    p{
                        color: #ffffff;
                        text-align: center;
                    }
                    p:first-child {
                        font-size: 30px;
                        padding-top: 3px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 2px;
                    }
                }
                .title::after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background-color: black;
                    transform: skewX(-25deg);
                    z-index: -1;
                }
                .title::before {
                    content: '';
                    display: block;
                    position: absolute;
                    left: -10px;
                    top: 0;
                    width: 10px;
                    height: 75px;
                    transform: skewX(-25deg);
                    background-color: #e21711;
                    z-index: -1;
                }
                .card {
                    margin-top: 90px;
                }
                .wrap {
                    position: relative;
                    width: 1320px;
                    height: 360px;
                    margin: 60px auto;
                    .content {
                        position: relative;
                        width: 1320px;
                        height: 360px;
                        li{
                            position: absolute;
                            // background-size: 100% 100%;
                            cursor: pointer;
                            background-position: center;
                            background-size: cover;
                        }
                    }
                   
                }
                
                .wrap a {
                    position: absolute;
                    display: block;
                    z-index: 2;
                    top: 50%;
                    width: 60px;
                    height: 60px;
                    line-height: 60px;
                    margin-top: -30px;
                    font: 36px/60px "宋体";
                    text-align: center;
                    text-decoration: none;
                    color: #fff;
                    background-color: #e21711;
                    
                }
                .wrap a::after {
                    content: '';
                    display: block;
                    position: absolute;
                    width: 18px;
                    height: 27px;
                    left: 50%;
                    margin-left: -9px;
                    top: 16px;
                    background: url(../../static/img/left_ico.png)no-repeat center center;
                }
                .wrap a:last-child {
                    transform: rotateY(180deg)
                }
                .prev {
                    left: 30px;
                    background-color: #e21711;
                }
                .next {
                    right: 30px;
                }
            }
            .exhibition {
                margin-top: 190px;
                // margin-left: 300px;
                // margin-right: 300px;
                margin-bottom: 90px;
                .title {
                    width: 450px;
                    height: 75px;
                    position: relative;
                    margin: 0 auto;
                    p{
                        color: #ffffff;
                        text-align: center;
                    }
                    p:first-child {
                        font-size: 30px;
                        padding-top:3px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 2px;
                    }
                }
                .title::after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background-color: black;
                    transform: skewX(-25deg);
                    z-index: -1;
                }
                .title::before {
                    content: '';
                    display: block;
                    position: absolute;
                    left: -10px;
                    top: 0;
                    width: 10px;
                    height: 75px;
                    transform: skewX(-25deg);
                    background-color: #e21711;
                    z-index: -1;
                }
                .exhibition_list {
                    margin: 0 auto;
                    margin-top: 60px;
                    width: 1320px;
                    ul {
                         width: 1320px;
                        li {
                            width: 432px;
                            height: 344px;
                            float: left;
                            background-color: #fff;
                            box-shadow:-3px 0 5px rgba(222, 222, 222, 0.8),3px 0 5px rgba(222, 222, 222, 0.8),
                            0 -3px 5px rgba(222, 222, 222, 0.8), 0 3px 5px rgba(222, 222, 222, 0.8);
                            position: relative;
                            margin-right: 12px;
                            cursor: pointer;
                            .picter {
                                height: 241px;
                                img {
                                    width: 430px;
                                    height: 240px;
                                    margin-top: 1px;
                                }
                            }
                            .text {
                                width: 432px;
                                height: 103px;
                                position: relative;
                                text-align: left;
                                &:hover {
                                    p {
                                        color: #e21711;
                                    }
                                    span {
                                        color: #e21711; 
                                    }
                                }
                                p {
                                    font-size: 24px;
                                    color: #000000;
                                    padding: 18px 0 0 20px;
                                    white-space: nowrap;
                                     overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                span {
                                    font-size: 16px;
                                    color: #606060;
                                    margin: 10px 0 0px 20px;
                                    display: block;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                            }
                            .text::before {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 1px;
                                width: 430px;
                                height: 1px;
                                background-color: #d6d6d6;
                            }
                        }
                        :nth-child(3) {
                            margin-right: 0;
                        }
                        .clear {
                            clear: both;
                            float:none;
                            
                        }
                    }
                }
                .more {
                    width: 197px;
                    height: 54px;
                    margin: 0 auto;
                    margin-top: 48px;
                    background-color: #e21711;
                    text-align: center;
                    line-height: 54px;
                    cursor: pointer;
                    span {
                        color: #fff;
                        font-size: 20px;
                    }
                    span:last-child {
                        padding-top: 5px;
                    }
                }

            }
            .enterprise_intro {
                background: url(../../static/img/exhibition_bg.png)no-repeat center center;
                background-size: cover;
                height: 761px;
                border-top: 1px solid #fff;
                 .title {
                    width: 450px;
                    height: 75px;
                    position: relative;
                    margin: 0 auto;
                    margin-top: 100px;
                    p{
                        color: #ffffff;
                        text-align: center;
                        z-index:2;
                        position: relative;
                    }
                    p:first-child {
                        font-size: 30px;
                        padding-top: 3px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 2px;
                    }
                }
                .title::after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background-color: black;
                    transform: skewX(-25deg);
                    z-index: 1;
                }
                .title::before {
                    content: '';
                    display: block;
                    position: absolute;
                    left: -10px;
                    top: 0;
                    width: 10px;
                    height: 75px;
                    transform: skewX(-25deg);
                    background-color: #e21711;
                    z-index: 1;
                }
                .english_intro {
                    margin: 50px 0 60px 0;
                    font-size: 16px;
                    color: #606060;
                }
                .content_intro {
                    overflow: hidden;
                    // margin-left: 382px;
                    width: 1200px;
                    margin: 0 auto;
                    .intro_left {
                        float: left;
                        height: 302px;
                        img {
                            width: 540px;
                            height: 302px;
                        }
                    }
                    .intro_right {
                        float: left;
                        margin-left: 85px;
                        height: 302px;
                        .company_name {
                            text-align: left;
                            span {
                                font-size: 25px;
                                color: #000000;
                            }
                        }
                        .company_intro {
                            width: 509px;
                            text-align: left;
                            margin-top: 40px;
                            line-height: 30px;
                            span {
                                font-size: 16px;
                                color: #606060
                            }
                        }
                        .company_intro_en {
                            width: 586px;
                        }
                        .company_more {
                            width: 197px;
                            height: 55px;
                            background-color: #e21711;
                            margin-top: 84px;
                            cursor: pointer;
                            p {
                                color: #ffffff;
                            }
                            p:first-child {
                                font-size: 20px;
                                height: 24px;
                                padding-top: 6px;
                            }
                            p:last-child {
                                font-size: 14px;
                                height: 18px;
                            }
                        }
                        .company_more_en {
                            margin-top: 28px;
                        }
                    }
                    .intro_right_en {
                        margin-left: 72px;
                    }
                }
            }
        }  
    }
    @media screen and (min-width:1280px) and (max-width:1300px){
        .container {
            .header_info {
                .info {
                    margin-left: 400px;
                }
            }
        }
        
    }
    @media screen and (min-width:1180px) and (max-width:1280px){
        .container {
            .header_info {
                .info {
                    margin-left: 300px;
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 200px;
                    }
                }
            }
        }
        
    }
    @media screen and (min-width:960px) and (max-width:1180px){
        .container {
            .header_info {
                .info {
                    margin-left: 350px;
                    .language {
                        margin-left: 130px;
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 100px;
                    }
                }
            }
        }
        
    }
    @media screen and (min-width:860px) and (max-width:960px){
        .container {
            .header_info {
                .info {
                    margin-left: 120px;
                    .language {
                        margin-left: 120px;
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 20px;
                    }
                    .menu_list {
                        margin-left: 24px;
                    }
                }
            }
        }
        
    }
    @media screen and (min-width:750px) and (max-width:860px){
        .container {
            .header_info {
                .info {
                    margin-left: 80px;
                    .language {
                        margin-left: 80px;
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        display: none;
                        
                    }
                }
            }
        }
        
    }
</style>
<style lang="less">
.banner {
    .el-carousel__arrow {
        width: 38px;
        height: 78px;
        border-radius: 0;
    }
    .el-carousel__arrow--left {
        left: 120px;
        .el-icon-arrow-left {
            width: 12px;
            height: 20px;
            background: url(../../static/img/right_ico.png)no-repeat center center;
            transform: rotateY(180deg)
        }
        .el-icon-arrow-left:before {
            content: ''
        }
    }
    .el-carousel__arrow--right {
        right:120px;
        .el-icon-arrow-right {
            width: 12px;
            height: 20px;
            background: url(../../static/img/right_ico.png)no-repeat center center;
        }
        .el-icon-arrow-right:before {
            content: ''
        }
    }
    .is-active .el-carousel__button {
        width: 110px;
        height: 8px;
        background-color: #e21711;
    }
    .el-carousel__button {
        width: 110px;
        height: 8px;
        background-color: rgba(105, 105, 105, 0.7);
    }
}
.card {
    width: 1320px;
    margin: 0 auto;
    overflow: hidden;
    .el-carousel__arrow {
        width: 54px;
        height: 54px;
        border-radius: 0;
        background-color: #e21711;
        
    }
    .el-carousel__container {
        overflow: hidden;
    }
    .el-carousel__item--card {
    
    }
    .el-carousel__item--card.is-in-stage {
       

    }
    .el-carousel__arrow--left {
        left: 120px;
        .el-icon-arrow-left {
            width: 17px;
            height: 27px;
            background: url(../../static/img/left_ico.png)no-repeat center center;
        }
        .el-icon-arrow-left:before {
            content: ''
        }
    }
    .el-carousel__arrow--right {
        right:120px;
        .el-icon-arrow-right {
            width: 18px;
            height: 27px;
            background: url(../../static/img/left_ico.png)no-repeat center center;
             transform: rotateY(180deg)
        }
        .el-icon-arrow-right:before {
            content: ''
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/home.vue